import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LadderBoardComponent } from './ladder-board/ladder-board.component';

const routes: Routes = [
  {
    path:'ladder',
    component:LadderBoardComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LadderBoardRoutingModule { }
